var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15Z",
    fill: "#A5ACBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16Z",
    fill: "#A5ACBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19H18V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V19H8V20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20L6 19H5C4.44772 19 4 18.5523 4 18V11C3.44772 11 3 10.5523 3 10V8C3 7.44772 3.44772 7 4 7H4.12602C4.57006 5.27477 6.13616 4 8 4H16C17.8638 4 19.4299 5.27477 19.874 7H20C20.5523 7 21 7.44772 21 8V10C21 10.5523 20.5523 11 20 11V18C20 18.5523 19.5523 19 19 19ZM8 6H16C17.1046 6 18 6.89543 18 8V11H6V8C6 6.89543 6.89543 6 8 6ZM6 13V17H18V13H6Z",
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.89cee374755ad60dcc01c9e7d8838f83.svg";
export { ForwardRef as ReactComponent };